import React from "react";

export default React.createClass({
    render: function(){

        return(
            <div id={this.props.field + "-group"} className="form-div row">
              <div className={this.props.bigLabel ? "col-sm-7" : "col-sm-4"}>
                <label htmlFor={this.props.field}>{this.props.label}
                {this.props.requiredField && this.props.label != "" &&
                  <span className="requiredField"> * </span>
                }
                </label>
              </div>
              <div className={this.props.bigLabel ? "col-sm-5" : "col-sm-8"}>
                {this.props.requiredField &&
                  <input type="text" name={this.props.field} id={this.props.field} placeholder={this.props.placeholder} defaultValue={this.props.defaultValue} required />
                }
                {!this.props.requiredField &&
                  <input type="text" name={this.props.field} id={this.props.field} placeholder={this.props.placeholder} defaultValue={this.props.defaultValue} />
                }
              </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/js/components/elements/text-row.jsx